import { render, staticRenderFns } from "./ppt-task.vue?vue&type=template&id=ff01274a"
import script from "./ppt-task.vue?vue&type=script&lang=js"
export * from "./ppt-task.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff01274a')) {
      api.createRecord('ff01274a', component.options)
    } else {
      api.reload('ff01274a', component.options)
    }
    module.hot.accept("./ppt-task.vue?vue&type=template&id=ff01274a", function () {
      api.rerender('ff01274a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/curriculum-manage/components/ppt-task.vue"
export default component.exports